import React from 'react';

const AutomationPage = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">
        AI Automation Platform
      </h1>
      
      <div className="prose dark:prose-invert max-w-none">
        <h2 className="text-2xl font-semibold mb-4">
          Transform Your Operations with Intelligent Automation
        </h2>
        
        <p className="mb-6">
          Our AI Automation Platform helps organizations streamline their processes, reduce manual work, 
          and achieve unprecedented efficiency through the power of artificial intelligence and machine learning.
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-4">Intelligent Process Automation</h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Automated workflow orchestration</li>
              <li>Smart document processing</li>
              <li>Natural language understanding</li>
              <li>Adaptive learning capabilities</li>
            </ul>
          </div>

          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-4">Advanced AI Features</h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Predictive analytics</li>
              <li>Cognitive decision making</li>
              <li>Pattern recognition</li>
              <li>Anomaly detection</li>
            </ul>
          </div>
        </div>

        <h2 className="text-2xl font-semibold mb-4">
          Key Benefits
        </h2>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg">
            <h3 className="text-lg font-semibold mb-2">Increased Efficiency</h3>
            <p>Reduce manual tasks and streamline operations with intelligent automation</p>
          </div>

          <div className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg">
            <h3 className="text-lg font-semibold mb-2">Enhanced Accuracy</h3>
            <p>Minimize errors and improve consistency with AI-powered processes</p>
          </div>

          <div className="bg-gray-50 dark:bg-gray-900 p-6 rounded-lg">
            <h3 className="text-lg font-semibold mb-2">Scalable Solutions</h3>
            <p>Easily adapt and scale your automation as your needs grow</p>
          </div>
        </div>

        <div className="bg-primary-50 dark:bg-primary-900 p-8 rounded-lg mb-12">
          <h2 className="text-2xl font-semibold mb-4">
            Ready to Get Started?
          </h2>
          <p className="mb-6">
            Transform your organization with our AI Automation Platform. Contact our team to learn more 
            about how we can help you achieve your automation goals.
          </p>
          <button className="btn-primary">
            Schedule a Demo
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutomationPage; 